import logo from 'static/logo.png';
import { css } from '@emotion/css';
import { useHistory } from 'react-router-dom';

const Logo = () => {
  const history = useHistory();
  return <img className={cssLogo} src={logo} alt="" onClick={() => history.push('/')} />;
};

export default Logo;

const cssLogo = css`
  width: 150px;
  height: 40px;
  cursor: pointer;
`;
